module.exports = __webpack_public_path__ + "img/phone-icon.55bcaa6f.svg";